module.exports = __webpack_public_path__ + "img/bullish.d182b3df.jpg";